import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/transporters`;
export const API_URL_USER = `${process.env.REACT_APP_API_URL}/transporters/users`;

// CREATE =>  POST: add a new product to the server
export function createTransporter(transporter) {
    return axios.post(API_URL, { ...transporter });
}

// READ
export function getAllTransporters() {
    return axios.get(API_URL);
}

export function getPaginatedTransporters(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getTransporterById(transporterId) {
    return axios.get(`${API_URL}/${transporterId}`);
}

export function createUser(user) {
    return axios.post(`${API_URL_USER}`, { ...user })
}



// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the transporter on the server
export function updateTransporter(transporterId, transporter) {
    return axios.put(`${API_URL}/${transporterId}`, { ...transporter });
}


// DELETE => delete the product from the server
export function deleteTransporter(transporterId) {
    return axios.delete(`${API_URL}/${transporterId}`);
}
